import { isInsideZyVersion } from '@/lib/zy-tiptap-utils';
import { Layers3 } from 'lucide-react';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyVersionWrapButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyVersionInline"
        extensionType="node"
        icon={Layers3}
        label="Toggle zyVersion"
        command={editor => editor.commands.toggleOrInsertZyVersion()}
        isActive={isInsideZyVersion}
        ref={ref}
        {...props}
    />
));

ZyVersionWrapButton.displayName = 'ZyVersionWrapButton';

export default ZyVersionWrapButton;
